"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmailComposer } from "../context";
import { useEditorState } from "@tiptap/react";
import { BubbleMenu } from "@tiptap/react/menus";
import { LinkMenuState } from "./link-bubble-menu-handler";
import { LinkEditor } from "./link-editor";
function useLinkMenuState() {
  const $ = _c(2);
  const {
    editor
  } = useEmailComposer();
  let t0;
  if ($[0] !== editor) {
    t0 = {
      editor,
      selector: _temp
    };
    $[0] = editor;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useEditorState(t0);
}

/**
 * Composable bubble menu that appears when the cursor is on a link.
 * Reads show/hide and view/edit state from the LinkBubbleMenuHandler extension.
 *
 * Usage: <EmailComposer.LinkBubbleMenu />
 */
function _temp(ctx) {
  return (ctx.editor?.storage as any)?.linkBubbleMenu?.state as LinkMenuState | undefined ?? LinkMenuState.HIDDEN;
}
export function LinkBubbleMenu() {
  const {
    editor,
    bubbleMenuContainerRef
  } = useEmailComposer();
  const menuState = useLinkMenuState();
  if (!editor || !menuState || menuState === LinkMenuState.HIDDEN) return null;
  return <BubbleMenu editor={editor} options={{
    autoPlacement: {
      allowedPlacements: ["top", "bottom"],
      crossAxis: true
    },
    inline: true
  }} appendTo={bubbleMenuContainerRef.current ?? undefined} className="z-30">
      <div className="rounded-lg border border-border bg-background shadow-md px-2 py-1.5">
        <LinkEditor mode={menuState} />
      </div>
    </BubbleMenu>;
}